import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import ReactSVG from 'react-svg'

import PlusIcon from '../../../../../images/plus.svg'
import styles from './add-profile-button.css'

/** Renders the add-profile action and indicates when adding requires a plan upgrade. */
function AddProfileButton({ onClick, isProfileAllowBasicUpsell }) {
  return (
    <button
      type="button"
      className={styles.wrapper}
      onClick={onClick}
    >
      <span className={styles.circle}>
        <ReactSVG
          src={PlusIcon}
          wrapper="span"
          className={classNames(styles.plusIcon, isProfileAllowBasicUpsell && styles.disabledColor)}
        />
      </span>
      <span className={classNames(styles.title, isProfileAllowBasicUpsell && styles.disabledColor)}>
        Add profile
      </span>
    </button>
  )
}

AddProfileButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isProfileAllowBasicUpsell: PropTypes.bool
}

AddProfileButton.defaultProps = {
  isProfileAllowBasicUpsell: false
}

export default AddProfileButton
